<template>
  	<div class="rightBlock advancedTabC">
		<link v-bind:href="dynamicCssPath" rel="stylesheet" type="text/css">
		<el-container>
			<el-main>

				<div class="tab" style="display: block;">
          <child-adpc ref="childADPc"></child-adpc>

          <el-dialog :title="$t('advancedTab.dks')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogDKSVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-dksC :key="componentKey" ref="childdksc" @child-event="getData"></child-dksC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogDKSVisible = false">{{$t("advancedTab.cancelInfo")}}</el-button>
          <el-button type="primary" @click="saveDKS">{{$t("advancedTab.saveInfo")}}</el-button>
          </div>
          </el-dialog>

          <el-dialog :title="$t('advancedTab.mt')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogMTVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-mtC :key="componentKey" ref="childmtc"></child-mtC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogMTVisible = false">{{$t("advancedTab.cancelInfo")}}</el-button>
          <el-button type="primary" @click="saveMT">{{$t("advancedTab.saveInfo")}}</el-button>
          </div>
          </el-dialog>


          <el-dialog :title="$t('advancedTab.socd')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogSOCDVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-socdC :key="componentKey" ref="childsocdc"></child-socdC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogSOCDVisible = false">{{$t("advancedTab.cancelInfo")}}</el-button>
          <el-button type="primary" @click="saveSOCD">{{$t("advancedTab.saveInfo")}}</el-button>
          </div>
          </el-dialog>


          <el-dialog :title="$t('advancedTab.tgl')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogTGLVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-tglC :key="componentKey" ref="childtglc"></child-tglC>

            <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTGLVisible = false">{{$t("advancedTab.cancelInfo")}}</el-button>
            <el-button type="primary" @click="saveTGL">{{$t("advancedTab.saveInfo")}}</el-button>
            </div>
          </el-dialog>

          <el-dialog :title="$t('advancedTab.mpt')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogMPTVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-mptC :key="componentKey" ref="childmptc"></child-mptC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogMPTVisible = false">{{$t("advancedTab.cancelInfo")}}</el-button>
          <el-button type="primary" @click="saveMPT">{{$t("advancedTab.saveInfo")}}</el-button>
          </div>
          </el-dialog>


          <el-dialog :title="$t('advancedTab.end')"
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogENDVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-end :key="componentKey" ref="childendc"></child-end>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogENDVisible = false">{{$t("advancedTab.cancelInfo")}}</el-button>
          <el-button type="primary" @click="saveEND">{{$t("advancedTab.saveInfo")}}</el-button>
          </div>
          </el-dialog>

          <el-dialog :title="$t('advancedTab.rs')"
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogRSVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-rsC :key="componentKey" ref="childrsc"></child-rsC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogRSVisible = false">{{$t("advancedTab.cancelInfo")}}</el-button>
          <el-button type="primary" @click="saveRS">{{$t("advancedTab.saveInfo")}}</el-button>
          </div>
          </el-dialog>


					<div class="channel">
            
            <!-- <el-dropdown @command="handleTools">
              <el-button type="primary">
                {{$t("advancedTab.tools")}} <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="funcOP" slot="dropdown">
                <el-dropdown-item class="dks" command="dks">{{$t("advancedTab.dks")}}</el-dropdown-item>
                <el-dropdown-item class="rs" command="rs">{{$t("advancedTab.rs")}}</el-dropdown-item>
                <el-dropdown-item class="socd" command="socd">{{$t("advancedTab.socd")}}</el-dropdown-item>
                <el-dropdown-item class="mpt" command="mpt">{{$t("advancedTab.mpt")}}</el-dropdown-item>
                <el-dropdown-item class="mt" command="mt">{{$t("advancedTab.mt")}}</el-dropdown-item>
                <el-dropdown-item class="end" command="end">{{$t("advancedTab.end")}}</el-dropdown-item>
                <el-dropdown-item class="tgl" command="tgl">{{$t("advancedTab.tgl")}}</el-dropdown-item>
                <el-dropdown-item command="tools">快捷键功能（HOTKEY）</el-dropdown-item>
                <el-dropdown-item command="macro">宏功能（MACRO）</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->

            <div tip>{{$t("advancedTab.tip")}}</div>
						<el-tabs ref="tabs" v-model="tabName"  @tab-click="handleTabClick">

              <el-tab-pane :label="$t('advancedTab.socd')" name="SOCD">
                <div info>
                  <p>{{$t("advancedTab.socdInfo")}}</p>
                </div>

                <!-- <el-empty v-if="myfuns.length == 0" :description="$t('advancedTab.emptyInfo')"></el-empty> -->
                <ul class="functions scroll">

                  <li :style="getIconTypePath('REST','')"
                      data-type="REST"
                      data-name="REST"
                      data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>

                  <li :style="getIconTypePath('ADD','')"
                  data-type="CREATE"
                  data-name="CREATE"
                  data-task="CREATE" 
                  command="socd"
                  @click="handleTools('socd')"
                  ><span>{{$t("advancedTab.socd")}}</span></li>

                  <li v-for="(item, index) in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-index="index"
                    :data-md5="item.md5"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span> <i></i></li>
                </ul>
							</el-tab-pane>

							<el-tab-pane :label="$t('advancedTab.dks')" name="DKS">
                <div info>
                  <p>{{$t("advancedTab.dksInfo")}}</p>
                </div>
                <!-- <el-empty v-if="myfuns.length == 0" :description="$t('advancedTab.emptyInfo')"></el-empty> -->

                <ul class="functions scroll">
                  <li :style="getIconTypePath('REST','')"
                      data-type="REST"
                      data-name="REST"
                      data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>
                  <li :style="getIconTypePath('ADD','')"
                  data-type="CREATE"
                  data-name="CREATE"
                  data-task="CREATE" 
                  command="dks"
                  @click="handleTools('dks')"
                  ><span>{{$t("advancedTab.dks")}}</span></li>

                  <li v-for="(item, index) in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-index="index"
                    :data-md5="item.md5"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span> <i></i></li>
                </ul>
							</el-tab-pane>

              <!-- <el-tab-pane :label="$t('advancedTab.rs')" name="RS">
                <div info>
                  <p>{{$t("advancedTab.rsInfo")}}</p>
                </div>

                <el-empty v-if="myfuns.length == 0" :description="$t('advancedTab.emptyInfo')"></el-empty>
                <ul class="functions scroll">

                  <li :style="getIconTypePath('REST','')"
                      data-type="REST"
                      data-name="REST"
                      data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>

                  <li v-for="(item, index) in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-index="index"
                    :data-md5="item.md5"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span> <i></i></li>
                </ul>
							</el-tab-pane> -->

							<el-tab-pane :label="$t('advancedTab.mpt')" name="MPT">
                <div info>
                  <p>{{$t("advancedTab.mptInfo")}}</p>
                </div>
                <!-- <el-empty v-if="myfuns.length == 0" :description="$t('advancedTab.emptyInfo')"></el-empty> -->
                <ul class="functions scroll">
                  <li :style="getIconTypePath('REST','')"
                  data-type="REST"
                  data-name="REST"
                  data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>
                  <li :style="getIconTypePath('ADD','')"
                  data-type="CREATE"
                  data-name="CREATE"
                  data-task="CREATE" 
                  command="mpt"
                  @click="handleTools('mpt')"
                  ><span>{{$t("advancedTab.mpt")}}</span></li>


                  <li v-for="item in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-index="index"
                    :data-md5="item.md5"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span><i></i></li>
                </ul>
              </el-tab-pane>
							<el-tab-pane :label="$t('advancedTab.mt')" name="MT">
                <div info>
                  <p>{{$t("advancedTab.mtInfo")}}</p>
                </div>
                <!-- <el-empty v-if="myfuns.length == 0" :description="$t('advancedTab.emptyInfo')"></el-empty> -->

                <ul class="functions scroll">

                  <li :style="getIconTypePath('REST','')"
                  data-type="REST"
                  data-name="REST"
                  data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>
                  <li :style="getIconTypePath('ADD','')"
                  data-type="CREATE"
                  data-name="CREATE"
                  data-task="CREATE" 
                  command="mt"
                  @click="handleTools('mt')"
                  ><span>{{$t("advancedTab.mt")}}</span></li>


                  <li v-for="item in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-index="index"
                    :data-md5="item.md5"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span> <i></i></li>
                </ul>
              </el-tab-pane>
              <el-tab-pane :label="$t('advancedTab.end')" name="END">

                <div info>
                  <p>{{$t("advancedTab.endInfo")}}</p>
                </div>

                <!-- <el-empty v-if="myfuns.length == 0" :description="$t('advancedTab.emptyInfo')"></el-empty> -->

                <ul class="functions scroll">

                  <li :style="getIconTypePath('REST','')"
                  data-type="REST"
                  data-name="REST"
                  data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>
                  <li :style="getIconTypePath('ADD','')"
                  data-type="CREATE"
                  data-name="CREATE"
                  data-task="CREATE" 
                  command="end"
                  @click="handleTools('end')"
                  ><span>{{$t("advancedTab.end")}}</span></li>

                  <li v-for="item in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-index="index"
                    :data-md5="item.md5"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span> <i></i></li>
                </ul>
              </el-tab-pane>
							<el-tab-pane :label="$t('advancedTab.tgl')" name="TGL">

                <div info>
                  <p>{{$t("advancedTab.tglInfo")}}</p>
                </div>
                <!-- <el-empty v-if="myfuns.length == 0" :description="$t('advancedTab.emptyInfo')"></el-empty> -->

                  <ul class="functions scroll">
                    <li :style="getIconTypePath('REST','')"
                    data-type="REST"
                    data-name="REST"
                    data-task="REST"
                    ><span>{{$t("advancedTab.rest")}}</span></li>
                    <li :style="getIconTypePath('ADD','')"
                    data-type="CREATE"
                    data-name="CREATE"
                    data-task="CREATE" 
                    command="tgl"
                    @click="handleTools('tgl')"
                    ><span>{{$t("advancedTab.tgl")}}</span></li>


                    <li v-for="item in myfuns"
                      :style="getIconTypePath(item.type,item.icon)"
                      :data-index="index"
                      :data-md5="item.md5"
                      :data-type="item.type"   
                      :data-name="item.name" 
                      :data-task="item.content"
                    ><span>{{showCommandName(item)}}</span> <i></i></li>
                  </ul>

              </el-tab-pane>
						</el-tabs>						
					</div>
				</div>
			</el-main>
		</el-container>
	</div>
</template>
<script>
import $ from 'jquery'
import Base64 from 'base-64';
import SparkMD5 from 'spark-md5';
import KeyboardMapConf from '../../../../theme/keyboard.map.json';
import cmd10 from '../../../../theme/cmd1.0.config.json';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';
// 命令数据功能操作对象
import { CommandHandle } from '../../../../utils/command_handle.js';
import { ToolsHandle } from '../../../../utils/tools.js';


import adpC from './buttonTabPane/advancedProduct.vue'
import buttonPaneC from './buttonTabPane/buttonPaneC.vue'

import toolsC from '../../../../components/box/tools.vue'
import macroC from '../../../../components/box/macro.vue'
import dksC from '../../../../components/box/dks.vue'
import mtC from '../../../../components/box/mt.vue'
import tglC from '../../../../components/box/tgl.vue'
import mptC from '../../../../components/box/mpt.vue'
import endC from '../../../../components/box/end.vue'
import socdC from '../../../../components/box/socd.vue'
import rsC from '../../../../components/box/rs.vue'

export default {
  name: 'advancedTabC',
  components: 
  {
      'child-adpc':adpC,
	    buttonPaneC,
      'child-toolsc':toolsC,
      'child-macroC':macroC,
      'child-dksC':dksC,
      'child-mtC':mtC,
      'child-tglC':tglC,
      'child-mptC':mptC,
      'child-end':endC,
      'child-socdC':socdC,
      'child-rsC':rsC
  },
  data() {

    return {
      ThemeConf:null,
	    HIDDeviceObj:null,
      tabName: 'SOCD',
      componentKey:0,
      msg:"",
      msgShow:false,
      myfuns:[],
      dialogToolsVisible:false,
      dialogMacroVisible:false,
      dialogDKSVisible:false,
      dialogMTVisible:false,
      dialogTGLVisible:false,
      dialogMPTVisible:false,
      dialogENDVisible:false,
      dialogSOCDVisible:false,
      dialogRSVisible:false,
      dragging: false,
      mouseX: 0,
      mouseY: 0,
      initialX: 0,
      initialY: 0,
      offsetX: 0,
      offsetY: 0,
      RTStep:0.02
    }
  },
  mounted() 
  {
      this.$refs.tabs.$el.querySelector(".el-tabs__active-bar").style.width = "100px";

       //刷新自定义命令数据
      this.refreshData("SOCD");
      setTimeout(()=>{this.JQSetAD();},3000);
  },
  methods: 
  {
    getData()
    {
        return this.RTStep;
    },
    //刷新自定义命令数据
    init()
    {
        const ChildProductBottonC = this.$refs.childADPc;
              ChildProductBottonC.KeyMap = this.HIDDeviceObj.MatrixList.KeyMap;
              ChildProductBottonC.HIDDeviceObj = this.HIDDeviceObj;
              ChildProductBottonC.setProductImagePath();

        for(let i in this.ThemeConf.DeviceList)
        {
            if(this.ThemeConf.DeviceList[i].FirmwareVer == this.HIDDeviceObj.FirmwareVer)
            {
              this.RTStep = this.ThemeConf.axisSet.RT;//this.ThemeConf.DeviceList[i].RT;
              break;
            }
        }
    },
    //读取按键工作模式，高级功能
    async readLayout8Custom()
    {
        this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.MODE;
        let commandButtonModeGroups = this.HIDDeviceObj.getButtonLayout8CustomCommand(cmd10);

        for(let i in commandButtonModeGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonModeGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(3);
        }

        await ToolsHandle.delay(100);

        this.HIDDeviceObj.formatLayout8(this.HIDDeviceObj);
        this.init();
        this.$notify.closeAll();
    },
    JQSetAD()
    {
      var context = this;
      //JQ操作
      $(function() 
      {   
          //删除命令
          $(".advancedTabC .functions").on("click","li i",function()
          {
              var md5 = $(this).parent().attr("data-md5");
              var index = $(this).parent().attr("data-index");
              var name = $(this).parent().attr("data-name");
              var task = $(this).parent().attr("data-task");
              var type = $(this).parent().attr("data-type");

              context.$confirm(context.$i18n.t("msg.confirmInfoDel"), context.$i18n.t("msg.confirmTitDel"), 
              {
                confirmButtonText:  context.$i18n.t("msg.confirmOKDel"),
                cancelButtonText: context.$i18n.t("msg.confirmNoDel"),
                type: 'warning'
              }).then(() => 
              {
                  CommandHandle.delCommad(md5);
                  $(this).parent().remove();

              }).catch(() => {});

    
              return false;
          });

          $(".advancedTabC .functions").on("contextmenu click","li",function()
          {
              var md5 = $(this).attr("data-md5");
              var name = $(this).attr("data-name");
              var task = $(this).attr("data-task");
              var type = $(this).attr("data-type");

              //功能编辑页面
              context.enterEditPage(type,md5,name,task);
          });
          //多功能功能键设置
          $(".advancedTabC .functions").on("click","li",function()
          {
              var md5 = $(this).attr("data-md5");
              var name = $(this).attr("data-name");
              var task = $(this).attr("data-task");
              var type = $(this).attr("data-type");
              var button = $(".advancedTabC .buttons li.on");

              //设置异常处理
              if(button.length == 0)
              {
                if(name == "REST")
                {
                  context.$message({message:context.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
                  return false;
                }

                // context.$confirm(context.$i18n.t("msg.commandSelectWarn"), context.$i18n.t("msg.confirmTitCommand"), 
                // {
                //   confirmButtonText:  context.$i18n.t("msg.confirmOKCommand"),
                //   cancelButtonText: context.$i18n.t("msg.confirmNoCommand"),
                //   type: 'warning'
                // }).then(() => 
                // {
                //   //功能编辑页面
                //   context.enterEditPage(type,md5,name,task);

                // }).catch(() => {});

                // return false;
              }
              
              //功能设置开始
              switch(type)
              {
                case "REST":
                {
                    var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,button.attr("name"));
                    //恢复高级功能
                    cmd10.SET_DEVICE_BUTTON_DEL_CMD[5] = buttonObj.Hid;
                    const outputReportData1 = new Uint8Array(cmd10.SET_DEVICE_BUTTON_DEL_CMD.map(hex => parseInt(hex, 16)));
                    context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData1);

                    //刷新UI
                    context.refreshAdKeyData(button.attr("name"),"","");

                }break;
              }

              // context.readLayout8Custom();
          });
      });

    },
    //获取图标
    getIconPath(name)
    {
        let imgUrl = require("../../../../asserts/image/command_icon/" + name);   
        
        return '--bgurl: url(' + imgUrl + ')';
    },
    //获取TYPE图标
    getIconTypePath(name,icon)
    {
        let imgUrl = require("../../../../asserts/image/tools/" + name + ".png");   
        
        return '--bgurl: url(' + imgUrl + ')';
    },
    //显示命令名称
    showCommandName(item)
    {
        if(item.type == 'HOTKEY')
        {
          return item.name == ''?item.content:item.name;
        }
        else if (item.type == 'SOCD')
        {
          return item.content;
        }
        else 
        {
          return item.name == ''?item.type:item.name;
        }
    },
    //刷新按键自定义数据
    refreshAdKeyData(keyName,type,custom)
    {
        let mapData = this.HIDDeviceObj.MatrixList.KeyMap;
        //组装矩阵数据
        for(let i=0;i<mapData.length;i++)
        {
          for(let j=0;j<mapData[i].length;j++)
          {
              let bottonObj = mapData[i][j];
              let keyNameFromMap = bottonObj.key_name;
              if(keyName == 0)
                  continue;

              if(keyName == keyNameFromMap)
              {
                  mapData[i][j].working_mode = type;
              }
          }
        }

        //刷新数据
        const ChildProductBottonC = this.$refs.childADPc;
              ChildProductBottonC.KeyMap = mapData;

        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});

    },
    //刷新命令数据
    refreshData(type)
    {
      CommandHandle.initCommand();
      this.myfuns = CommandHandle.getCommandForType(type);
    },
    handleTabClick(tab, event) 
    { 
      this.componentKey += 1;

      let tabName = tab.name;
      this.refreshData(tabName);
    },
    handleTools(type)
    {
        this.componentKey += 1;
        switch(type)
        { 
          case  "tools":
          {
            this.dialogToolsVisible = true;
          }break;
          case  "macro":
          {
            this.dialogMacroVisible = true;
          }break;
          case  "dks":
          {
            this.dialogDKSVisible = true;

            setTimeout(()=>
            {
              const dksC = this.$refs.childdksc; 
                    dksC.RTStep = this.RTStep;
            },100);

          }break;
          case  "mt":
          {
            this.dialogMTVisible = true;
          }break;
          case  "tgl":
          {
            this.dialogTGLVisible = true;
          }break;
          case  "mpt":
          {
            this.dialogMPTVisible = true;
            setTimeout(()=>
            {
              const mptC = this.$refs.childmptc;
                    mptC.RTStep = this.RTStep;
            },100);
          }break;
          case  "end":
          {
            this.dialogENDVisible = true;
          }break;
          case  "socd":
          {
            this.dialogSOCDVisible = true;
          }break;
          case  "rs":
          {
            this.dialogRSVisible = true;
          }break;
        }
    },
    //保存快捷键
    saveHotKey()
    {
      const context = this;
      const toolsC = this.$refs.childToolsc;
      if(toolsC.auxiliaryKeys.length== 0)
      {      
        this.msg = "请勾选辅助键！";
        this.msgShow = true;
        setTimeout(()=>{context.msgShow = false;},2000);
        return;
      }

      if(toolsC.key == "")
      {      
        this.msg = "请输入快捷键！";
        this.msgShow = true;
        setTimeout(()=>{context.msgShow = false;},2000);
        return;
      }

      let commandHotKey = CommandHandle.getHotKey(toolsC.auxiliaryKeys,toolsC.key);
          CommandHandle.hotkeyStructure.name = commandHotKey;
          CommandHandle.hotkeyStructure.content = commandHotKey;
          CommandHandle.insertCommand(CommandHandle.hotkeyStructure);

      //更新UI位置
      toolsC.auxiliaryKeys = [];
      toolsC.key = "";
      this.dialogToolsVisible = false;

      //刷新数据
      this.tabName = "HOTKEY";
      this.refreshData(this.tabName);

    },
    
    setENDCmd(key,task)
    {
      var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,key);
      var customObjs =  task.split("|");

      var taskObj = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObjs[0]);

          cmd10.SET_DEVICE_FUNCTION_END_CMD[5] = buttonObj.Hid;
          cmd10.SET_DEVICE_FUNCTION_END_CMD[6] = taskObj.Hid;

      //写入硬件
      const outputReportData = new Uint8Array(cmd10.SET_DEVICE_FUNCTION_END_CMD.map(hex => parseInt(hex, 16)));
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
    },
    //保存END
    saveEND()
    {
      const context = this;
      const endC = this.$refs.childendc;

      if(endC.key == "")
      {      
        this.msg = "请输入快捷键！";
        this.msgShow = true;
        setTimeout(()=>{context.msgShow = false;},2000);
        return;
      }

      let button = endC.setButton;
      let name = endC.funcName;
      CommandHandle.endStructure.content = endC.c1 + "|" + button;

      CommandHandle.endStructure.name = name;
      CommandHandle.endStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.endStructure.content));
      if(endC.md5 == "")
      {
        CommandHandle.insertCommand(CommandHandle.endStructure);
      }
      else
      {
        CommandHandle.updateCommad(endC.md5,CommandHandle.endStructure);
      }

      //更新UI位置
      
      // endC.key = "";
      this.dialogENDVisible = false;

      //刷新数据
      this.tabName = "END";
      this.refreshData(this.tabName);

      this.setENDCmd(button,CommandHandle.endStructure.content);
      this.readLayout8Custom();
    },
    
    getDKSCommand(row)
    {
        let commandFormat = [0,0,0,0,0,0,0];
        for(let i in row)
        {
            let name = row[i].replace("动作","");

            commandFormat[parseInt(name) - 1] = 1;
        }

        return commandFormat;
    },
    setDKSCmd(key,task)
    {
        //获取行程触发粒度
        let GetDKSJourney = function(Command)
        {
            let journey = 0;

            Command.shift();

            journey += parseInt(Command[0]);
            journey += parseInt(Command[1]) << 1;
            journey += parseInt(Command[2]) << 2;
            journey += parseInt(Command[3]) << 3;
            journey += parseInt(Command[3]) << 4;

            journey += parseInt(Command[4]) << 5;
            journey += parseInt(Command[5]) << 6; 
            journey += parseInt(Command[6]) << 7;

            return journey.toString(16);
        }

        var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,key);

        var customObjs =  task.split(",");
        var customObjItec1 = customObjs[0].split("|");
        var customObjItec2 = customObjs[1].split("|");
        var customObjItec3 = customObjs[2].split("|");
        var customObjItem4 = customObjs[3].split("|");

        var taskObj1 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObjItec1[0]);
        var taskObj2 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObjItec2[0]);
        var taskObj3 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObjItec3[0]);
        var taskObj4 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObjItem4[0]);


            //触发功能
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[5] = buttonObj.Hid;

            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[6] = taskObj1.Hid;
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[8] = taskObj2.Hid;
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[10] = taskObj3.Hid;
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[12] = taskObj4.Hid;

            //行程触发粒度
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[14] = GetDKSJourney(customObjItec1);
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[15] = GetDKSJourney(customObjItec2);
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[16] = GetDKSJourney(customObjItec3);
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[17] = GetDKSJourney(customObjItem4);

            //触发位置
            var journey = HIDDeviceObj.getHighLowBits(parseFloat(customObjs[customObjs.length-2])*1000);
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[18] = journey[0];
            cmd10.SET_DEVICE_FUNCTION_DKS_CMD[19] = journey[1];


        //写入硬件
        const outputReportData = new Uint8Array(cmd10.SET_DEVICE_FUNCTION_DKS_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
    },
    //保存DKS
    saveDKS()
    {
        const context = this;
        const dksC = this.$refs.childdksc;

        if(dksC.R0 == "" || dksC.R1 == "" || dksC.R2 == "" || dksC.R3 == "")
        {      
          this.msg = "请输入快捷键！";
          this.msgShow = true;
          setTimeout(()=>{context.msgShow = false;},2000);
          return;
        }

        let  button = dksC.setButton;
        let  name = dksC.funcName;
        let  row0 = this.getDKSCommand(dksC.row0);
        let  row1 = this.getDKSCommand(dksC.row1);
        let  row2 = this.getDKSCommand(dksC.row2);
        let  row3 = this.getDKSCommand(dksC.row3);

        
        CommandHandle.dksStructure.content = dksC.R0 + "|" + row0.join("|") + ","
        + dksC.R1 + "|" + row1.join("|") + ","
        + dksC.R2 + "|" + row2.join("|") + ","
        + dksC.R3 + "|" + row3.join("|") + "," 
        + dksC.mm + ","
        + button;
        CommandHandle.dksStructure.name = name;
        CommandHandle.dksStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.dksStructure.content));

        if(dksC.md5 == "")
        {
          CommandHandle.insertCommand(CommandHandle.dksStructure);
        }
        else
        {
          CommandHandle.updateCommad(dksC.md5,CommandHandle.dksStructure);
        }

        //更新UI位置
        dksC.R0 = "";
        dksC.R1 = "";
        dksC.R2 = "";
        dksC.R3 = "";
        dksC.row0 = [];
        dksC.row1 = [];
        dksC.row2 = [];
        dksC.row3 = [];
        
        this.dialogDKSVisible = false;

        //刷新数据
        this.tabName = "DKS";
        this.refreshData(this.tabName);
        this.setDKSCmd(button,CommandHandle.dksStructure.content);

        this.readLayout8Custom();
    },

    setMPTCmd(key,task)
    {
      var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,key);
      var customObj =  task.split("|");

      var taskObj1 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObj[0]);
      var taskObj2 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObj[2]);
      var taskObj3 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObj[4]);


      var delay1 = HIDDeviceObj.getHighLowBits(parseFloat(customObj[1])*1000);
      var delay2 = HIDDeviceObj.getHighLowBits(parseFloat(customObj[3])*1000);
      var delay3 = HIDDeviceObj.getHighLowBits(parseFloat(customObj[5])*1000);

          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[5] = buttonObj.Hid;

          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[6] = taskObj1.Hid;
          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[8] = taskObj2.Hid;
          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[10] = taskObj3.Hid;

          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[12] = delay1[0];
          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[13] = delay1[1];

          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[14] = delay2[0];
          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[15] = delay2[1];

          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[16] = delay3[0];
          cmd10.SET_DEVICE_FUNCTION_MPT_CMD[17] = delay3[1];


      //写入硬件
      const outputReportData = new Uint8Array(cmd10.SET_DEVICE_FUNCTION_MPT_CMD.map(hex => parseInt(hex, 16)));
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
    },
    //保存MPT
    saveMPT()
    {
        const context = this;
        const mptC = this.$refs.childmptc;

        if(mptC.c1 == "" || mptC.c2 == "" || mptC.c3 == "")
        {      
          this.msg = "请输入快捷键！";
          this.msgShow = true;
          setTimeout(()=>{context.msgShow = false;},2000);
          return;
        }

        let  button = mptC.setButton;
        let  name = mptC.funcName;
        CommandHandle.mptStructure.content = mptC.c1 + "|" + mptC.mpt1 
        + "|" + mptC.c2 + "|" + mptC.mpt2 
        + "|" + mptC.c3 + "|" + mptC.mpt3 + "|"
        + button;

        CommandHandle.mptStructure.name = name;
        CommandHandle.mptStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.mptStructure.content));
        if(mptC.md5 == "")
        {
          CommandHandle.insertCommand(CommandHandle.mptStructure);
        }
        else
        {
          CommandHandle.updateCommad(mptC.md5,CommandHandle.mptStructure);
        }

        
        //更新UI位置
        mptC.c1 = "";
        mptC.c2 = "";
        mptC.c3 = "";
        this.dialogMPTVisible = false;
        //刷新数据
        this.tabName = "MPT";
        this.refreshData(this.tabName);

        this.setMPTCmd(button,CommandHandle.mptStructure.content);
        this.readLayout8Custom();
    },
    
    setTGLCmd(key,task)
    {
      var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,key);
      var customObj =  task.split("|");

      var taskObj = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObj[0]);
      var delay = customObj[1]/10;
    
          cmd10.SET_DEVICE_FUNCTION_TGL_CMD[5] = buttonObj.Hid;
          cmd10.SET_DEVICE_FUNCTION_TGL_CMD[6] = taskObj.Hid;
          cmd10.SET_DEVICE_FUNCTION_TGL_CMD[8] = delay.toString(16);

      //写入硬件
      const outputReportData = new Uint8Array(cmd10.SET_DEVICE_FUNCTION_TGL_CMD.map(hex => parseInt(hex, 16)));
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
    },
    //保存TGL
    saveTGL()
    {
      const context = this;
      const tglC = this.$refs.childtglc;

      if(tglC.key == "")
      {      
        this.msg = "请输入快捷键！";
        this.msgShow = true;
        setTimeout(()=>{context.msgShow = false;},2000);
        return;
      }

      let  button = tglC.setButton;
      let  name = tglC.funcName;
      CommandHandle.tglStructure.content = tglC.c1 + '|' + tglC.delay + '|' + button;

      CommandHandle.tglStructure.name = name;
      CommandHandle.tglStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.tglStructure.content));
      if(tglC.md5 == "")
      {
        CommandHandle.insertCommand(CommandHandle.tglStructure);
      }
      else
      {
        CommandHandle.updateCommad(tglC.md5,CommandHandle.tglStructure);
      }


      //更新UI位置
      
      tglC.key = "";
      tglC.delay = 200;
      this.dialogTGLVisible = false;

      //刷新数据
      this.tabName = "TGL";
      this.refreshData(this.tabName);

      this.setTGLCmd(button,CommandHandle.tglStructure.content);
      this.readLayout8Custom();
    },
    
    setMTCmd(key,task)
    { 
      var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,key);
      var customObj =  task.split("|");

      var taskObj1 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObj[0]);
      var taskObj2 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,customObj[1]);
          taskObj1 = taskObj1?taskObj1:HIDDeviceObj.getBottonHidOJBFromTask(KeyboardMapConf,customObj[0]);
          taskObj2 = taskObj2?taskObj2:HIDDeviceObj.getBottonHidOJBFromTask(KeyboardMapConf,customObj[1]);


      var delay = customObj[2]/10;
          cmd10.SET_DEVICE_FUNCTION_MT_CMD[5] = buttonObj.Hid;
          cmd10.SET_DEVICE_FUNCTION_MT_CMD[6] = taskObj2.Hid;
          cmd10.SET_DEVICE_FUNCTION_MT_CMD[8] = taskObj1.Hid;
          cmd10.SET_DEVICE_FUNCTION_MT_CMD[10] = delay.toString(16);

      //写入硬件
      const outputReportData = new Uint8Array(cmd10.SET_DEVICE_FUNCTION_MT_CMD.map(hex => parseInt(hex, 16)));
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
    },
    //保存MT
    saveMT()
    {
      const context = this;
      const mtC = this.$refs.childmtc;

      if(mtC.c1 == "" || mtC.c2 == "")
      {
        this.msg = "请输入快捷键！";
        this.msgShow = true;
        setTimeout(()=>{context.msgShow = false;},2000);
        return;
      }

      let button = mtC.setButton;
      let name = mtC.funcName;
      CommandHandle.mtStructure.content = mtC.c1 + "|" + mtC.c2 + "|" + mtC.delay + "|" + button;

      CommandHandle.mtStructure.name = name;
      CommandHandle.mtStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.mtStructure.content));
      if(mtC.md5 == "")
      {
        CommandHandle.insertCommand(CommandHandle.mtStructure);
      }
      else
      {
        CommandHandle.updateCommad(mtC.md5,CommandHandle.mtStructure);
      }

      //更新UI位置
      mtC.c1 = "";
      mtC.c2 = "";
      mtC.delay = 200;
      this.dialogMTVisible = false;

      //刷新数据
      this.tabName = "MT";
      this.refreshData(this.tabName);

      this.setMTCmd(button,CommandHandle.mtStructure.content);
      this.readLayout8Custom();
    },
    
    setRSCmd(f1,f2)
    {
      var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,f1);
      var taskObj1 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,f2);

          cmd10.SET_DEVICE_FUNCTION_RS_CMD[5] = buttonObj.Hid;
          cmd10.SET_DEVICE_FUNCTION_RS_CMD[6] = taskObj1.Hid;
          cmd10.SET_DEVICE_FUNCTION_RS_CMD[7] = taskObj1.Hid;
          cmd10.SET_DEVICE_FUNCTION_RS_CMD[8] = buttonObj.Hid;

      //写入硬件
      const outputReportData = new Uint8Array(cmd10.SET_DEVICE_FUNCTION_RS_CMD.map(hex => parseInt(hex, 16)));
      this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
    },
    //保存RS
    saveRS()
    {
      const context = this;
      const rsC = this.$refs.childrsc;

      if(rsC.c1 == "" || rsC.c2 == "")
      {
        this.msg = "请输入快捷键！";
        this.msgShow = true;
        setTimeout(()=>{context.msgShow = false;},2000);
        return;
      }

      let name = rsC.funcName;
      CommandHandle.rsStructure.content = rsC.c1 + "|" + rsC.c2;

      CommandHandle.rsStructure.name = name;
      CommandHandle.rsStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.rsStructure.content));
      if(rsC.md5 == "")
      {
        CommandHandle.insertCommand(CommandHandle.rsStructure);
      }
      else
      {
        CommandHandle.updateCommad(rsC.md5,CommandHandle.rsStructure);
      }

      //更新UI位置
      // rsC.c1 = "";
      // rsC.c2 = "";
      rsC.delay = 200;
      this.dialogRSVisible = false;

      //刷新数据
      this.tabName = "RS";
      this.refreshData(this.tabName);

      this.setRSCmd(rsC.c1,rsC.c2);
      this.readLayout8Custom();
    },
    
    setSOCDCmd(f1,f2)
    {
        var taskObj1 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,f1);
        var taskObj2 = HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,f2);


            cmd10.SET_DEVICE_FUNCTION_SOCD_CMD[5] = taskObj1.Hid;
            cmd10.SET_DEVICE_FUNCTION_SOCD_CMD[6] = taskObj2.Hid;

            cmd10.SET_DEVICE_FUNCTION_SOCD_CMD[8] = taskObj2.Hid;
            cmd10.SET_DEVICE_FUNCTION_SOCD_CMD[9] = taskObj1.Hid;

        //写入硬件
        const outputReportData = new Uint8Array(cmd10.SET_DEVICE_FUNCTION_SOCD_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

    },
    //保存SOCD
    saveSOCD()
    {
      const context = this;
      const socdC = this.$refs.childsocdc;

      if(socdC.c1 == "" || socdC.c2 == "")
      {
        this.msg = "请设置功能按键！";
        this.msgShow = true;
        setTimeout(()=>{context.msgShow = false;},2000);
        return;
      }

      let name = socdC.funcName;
      CommandHandle.socdStructure.content = socdC.c1 + "|" + socdC.c2 + "|" + socdC.delay;

      CommandHandle.socdStructure.name = name;
      CommandHandle.socdStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.mtStructure.content));
      if(socdC.md5 == "")
      {
        CommandHandle.insertCommand(CommandHandle.socdStructure);
      }
      else
      {
        CommandHandle.updateCommad(socdC.md5,CommandHandle.socdStructure);
      }

      //刷新数据
      this.tabName = "SOCD";
      this.refreshData(this.tabName);
      this.setSOCDCmd(socdC.c1,socdC.c2,socdC.delay);
      this.readLayout8Custom();

      //更新UI位置
      socdC.aclick = "";
      socdC.apress = "";
      socdC.delay = 1;
      this.dialogSOCDVisible = false;
    },
    
    //功能编辑页面
    enterEditPage(type,md5,name,task)
    {
        var context = this;
        switch(type)
        {
          case "DKS":
          {       
            context.dialogDKSVisible = true;
            setTimeout(()=>
            {
              const ChildDKSC = context.$refs.childdksc;
                    ChildDKSC.editFunc(md5,name,task); 
                    ChildDKSC.RTStep = this.RTStep;
            },100);

          }break;
          case "MPT":
          {
            context.dialogMPTVisible = true;
            setTimeout(()=>
            {
              const ChildMPTC = context.$refs.childmptc;
                    ChildMPTC.editFunc(md5,name,task); 
                    ChildMPTC.RTStep = this.RTStep;
            },100);

          }break;
          case "MT":
          {
            context.dialogMTVisible = true;
            setTimeout(()=>
            {
              const ChildMTC = context.$refs.childmtc;
                    ChildMTC.editFunc(md5,name,task); 
            },100);

          }break;
          case "RS":
          {
            context.dialogRSVisible = true;
            setTimeout(()=>
            {
              const ChildRSC = context.$refs.childrsc;
                    ChildRSC.editFunc(md5,name,task); 
            },100);

          }break;
          case "END":
          {
            context.dialogENDVisible = true;
            setTimeout(()=>
            {
              const ChildENDC = context.$refs.childendc;
                    ChildENDC.editFunc(md5,name,task); 
            },300);

          }break;
          case "TGL":
          {
            context.dialogTGLVisible = true;
            setTimeout(()=>
            {
              const ChildTGLC = context.$refs.childtglc;
                    ChildTGLC.editFunc(md5,name,task); 
            },100);

          }break;
          case "SOCD":
          {
            context.dialogSOCDVisible = true;
            setTimeout(()=>
            {
              const ChildSOCDC = context.$refs.childsocdc;
                    ChildSOCDC.editFunc(md5,name,task); 
            },100);

          }break;
        }
    },
  },
  computed: 
  {
      dynamicCssPath: function() 
      {
        if(this.activeTab == 'button')
        {
          return 'css/buttonTabPane/button.css'; 
        }
        else if(this.activeTab == 'hotkey')
        {
          return 'css/buttonTabPane/hotkey.css';
        }
        else if(this.activeTab == 'app')
        {
          return 'css/buttonTabPane/app.css';
        }
        else if(this.activeTab == 'macro')
        {
          return 'css/buttonTabPane/macro.css';
        }
        else if(this.activeTab == 'advanced')
        {
          return 'css/buttonTabPane/advanced.css';
        }

        return 'css/buttonTabPane/button.css'; 
	  }
  }
}

</script>